import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Pricing as PricingComponent } from "@/components/Pricing";

const Pricing = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <PricingComponent />
      </main>
      <Footer />
    </div>
  );
};

export default Pricing;
